import { render, staticRenderFns } from "./ownerDetailChargeMachineOrder.vue?vue&type=template&id=48d21902&scoped=true"
import script from "./ownerDetailChargeMachineOrder.vue?vue&type=script&lang=js"
export * from "./ownerDetailChargeMachineOrder.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailChargeMachineOrder.vue?vue&type=style&index=0&id=48d21902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d21902",
  null
  
)

export default component.exports